import React from 'react';
import { Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIsMobile } from '../../../../util/style-utils';
import theme from '../../../../themes/theme';
import colors from '../../../../themes/main-colors';

const useStyles = (isMobile?: boolean) =>
  makeStyles(() => ({
    dotsContainer: {
      position: 'absolute',
      bottom: 20,
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      justifyContent: isMobile ? 'center' : 'start',
      background: 'transparent',
      [theme.breakpoints.down('sm')]: {
        padding: '30px 0',
        backgroundColor: 'transparent',
        position: 'static',
      },
    },
    dotsButton: {
      minWidth: theme.spacing(5.5),
      width: theme.spacing(5.5),
      height: theme.spacing(2),
      background: colors.sparkBlue,
      borderRadius: 'unset',
      '&:hover': {
        background: colors.sparkBlue,
      },
    },
    active: {
      background: `${colors.salmon} !important`,
    },
  }));

const Stepper = ({ activeStep, steps, setActiveStep }: any) => {
  const isMobile = useIsMobile();
  const classes = useStyles(isMobile)();

  return (
    <Box className={classes.dotsContainer}>
      {Array.from(Array(steps).keys()).map((step, index) => (
        <Button
          key={index}
          aria-label={`Carousel Entry ${index}`}
          onClick={() => setActiveStep(step)}
          className={`${classes.dotsButton} ${
            step === activeStep ? classes.active : ''
          }`}
        />
      ))}
    </Box>
  );
};

export default Stepper;
